import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DimensionServiceAckResponse, DimensionServiceModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { Dimension } from './dimension-service.entity';
import { DimensionDTO } from './dto/dimension.dto';

@Injectable()
export class DimensionServiceService {
    constructor(@InjectRepository(Dimension) private repository:  Repository<Dimension>) {
    }

    /**
     * Service to create new dimension record
     * @param dimensionDto 
     * @returns 
     */
     async createDimension(dimensionDto: DimensionDTO): Promise<DimensionServiceAckResponse> {
        const dimensionEntity = new Dimension();
        dimensionEntity.category = dimensionDto.category;
        dimensionEntity.categoryId = dimensionDto.categoryId;
        const boundaries = dimensionDto.boundaries.split(':');
        if(boundaries.length !== 3){
            throw new ErrorResponse(10000, 'Boundaries format not matched');
        }
        dimensionEntity.boundaries = dimensionDto.boundaries;
        dimensionEntity.plantId = dimensionDto.plantId;
        dimensionEntity.createdUser = dimensionDto.createdUser;
        const dimensionResponse = await this.repository.save(dimensionEntity);            
        if (dimensionResponse) {
            return new DimensionServiceAckResponse(true, 10000, 'Dimension Created Successfully');
        }
    }

    /**
     * Service to get all the history
     * @returns 
     */
    async getDimensions(): Promise<DimensionServiceAckResponse> {
        const dimensionResponse = await this.repository.find({
            order:{dimensionId: "ASC"},
        });

        const dimensionDetails: DimensionServiceModel[] = [];
        if (dimensionResponse.length === 0) {
            throw new ErrorResponse(9999, 'History not found');
        }
        for(const dimension of dimensionResponse) {
            const boundaries = dimension.boundaries.split(':');
            const dimensionModel = new DimensionServiceModel(dimension.categoryId,dimension.category,dimension.plantId,Number(boundaries[0]),Number(boundaries[1]),Number(boundaries[2]));
            dimensionDetails.push(dimensionModel);
        }
        return new DimensionServiceAckResponse(true, 10000, 'Dimension Details Retrived Successfully', dimensionDetails);       
    }


    /**
     * Service to get all the history by plant id
     * @param plantIdReq
     * @returns 
     */
     async getDimensionsByPlantId(plantIdReq: PlantIdRequest): Promise<DimensionServiceAckResponse> {
        const dimensionResponse = await this.repository.find({
            where:{plantId: plantIdReq.plantId},
            order:{dimensionId: "ASC"},
        });

        const dimensionDetails: DimensionServiceModel[] = [];
        if (dimensionResponse.length === 0) {
            throw new ErrorResponse(9999, 'History not found');
        }
        for(const dimension of dimensionResponse) {
            const boundaries = dimension.boundaries.split(':');
            const dimensionModel = new DimensionServiceModel(dimension.categoryId,dimension.category,dimension.plantId,Number(boundaries[0]),Number(boundaries[1]),Number(boundaries[2]));
            dimensionDetails.push(dimensionModel);
        }
        return new DimensionServiceAckResponse(true, 10000, 'Dimension Details Retrived Successfully', dimensionDetails);       
    }
}
